import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import SCModal from 'components/modals/sc-modal';

import ModalActions from 'components/modals/components/modal-actions';
import ModalContent from 'components/modals/components/modal-content';
import ModalTitle from 'components/modals/components/modal-title';
import SCButton from 'components/sc-button';
import globalMessages from 'intl/global-messages';

const AcknowledgementModal = ({modalTitle, open, onClose, onExited, size, children}) => {
    const {formatMessage} = useIntl();

    return (
        <SCModal open={open} size={size} onClose={onClose} onExited={onExited}>
            <ModalTitle title={modalTitle} />
            <ModalContent>{children}</ModalContent>
            <ModalActions>
                <SCButton
                    variant='secondary'
                    onClick={onClose}
                    label={formatMessage(globalMessages.close)}
                    disabled={false}
                    inProgress={false}
                />
            </ModalActions>
        </SCModal>
    );
};

AcknowledgementModal.propTypes = {
    modalTitle: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onExited: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    children: PropTypes.any,
};

AcknowledgementModal.defaultProp = {
    size: 'medium',
    onExited: noop,
};

export default AcknowledgementModal;
